/**
 * Status pill (design README shared kit). One pill = one status, everywhere identically: a dot +
 * label on the status-tinted background. Color is NEVER the only signal — the text label + dot
 * shape carry it (WCAG). Used on tracking + queue + timeline.
 */
import type { RequestStatus } from "@td/shared";
import { statusLabel, statusToken } from "./status.js";

export function StatusPill({
  status,
  size = "md",
}: {
  status: RequestStatus;
  size?: "sm" | "md";
}): JSX.Element {
  const token = statusToken(status);
  return (
    <span
      className={`td-pill td-pill--${size}`}
      style={{
        color: `var(--td-status-${token}-fg)`,
        background: `var(--td-status-${token}-bg)`,
      }}
    >
      <span
        className="td-pill__dot"
        style={{ background: `var(--td-status-${token}-dot)` }}
        aria-hidden="true"
      />
      {statusLabel(status)}
    </span>
  );
}
